//const NilID = "uLU5vVwNpEmFjeg4wchi"


const library = [
  {
    author: "J. G. Frazer",
    title: "Pausanias' Description of Greece",
    subtitle: "Translated with a commentary by J. G. Frazer",
    date: "1898",
    key: "Pausanias",
    id: "kMDtleXjL9S3C0otDqfg",
    firstChapterName: "Attica",
    firstSectionID: "F87rZHLgKuetdp9lloQH"
  },
  {
    author: "Martin P. Nilsson",
    title:
      "Griechische Feste von religiöser Bedeutung mit Ausschluss der Attischen",
    date: "1957",
    key: "Nilsson",
    id: "uLU5vVwNpEmFjeg4wchi",
    firstChapterName: "Aeolia with Lesbos and Tenedos",
    firstSectionID: "asZDKqR3SMow7ELzlfL9"
  }
];

export default library;



// WEBPACK FOOTER //
// ./src/data/library.js